export default {
  0: 'Никому',
  1: 'Только зарегистрированным',
  100: 'Всем пользователям',
};



// WEBPACK FOOTER //
// ./src/data/user-fields-visibility.js